import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CmsConfig, ConfigModule, I18nModule, provideDefaultConfig } from "@spartacus/core";
import { PageLayoutModule, OutletModule, OutletRefModule, PageSlotModule, ParagraphComponent, MediaModule } from "@spartacus/storefront";
import { KbProductCategoriesComponent } from "./kb-product-categories.component";
import { ReactiveFormsModule } from "@angular/forms";
import { BaseriesComparisionComponent } from "./baseries-comparision/baseries-comparision.component";



@NgModule({
    imports: [
        CommonModule,
        PageLayoutModule,
        OutletModule,
        OutletRefModule,
        PageSlotModule,
        I18nModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                baseriesComparisionPageFlexComponent: {
                    component: BaseriesComparisionComponent,
                }
            }
        })
    ],
    providers: [
    ],
    declarations: [KbProductCategoriesComponent, BaseriesComparisionComponent]
})
export class KbProductCategoriesModule {

}
